/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentDraftsControllerListQueryResponse, DocumentDraftsControllerListQueryParams, DocumentDraftsControllerList401, DocumentDraftsControllerList403 } from "../../models/documentDraftsController/DocumentDraftsControllerList";

function getDocumentDraftsControllerListUrl() {
  const res = { method: 'GET', url: `/api/v1/document-drafts` as const }  
  return res
}

/**
 * {@link /api/v1/document-drafts}
 */
export async function documentDraftsControllerList(params: DocumentDraftsControllerListQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentDraftsControllerListQueryResponse, ResponseErrorConfig<DocumentDraftsControllerList401 | DocumentDraftsControllerList403>, unknown>({ method : "GET", url : getDocumentDraftsControllerListUrl().url.toString(), params, ... requestConfig })  
  return res.data
}